<template>
  <div
    class="banner-background-area banner-background-area-bg bg-img section-space--ptb_120 bg-cover bg-gradient"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="saas-banner-background">
            <div class="content-wrapper">
              <h2
                class="heading_title text-white font-weight--light wow move-up"
              >
                PIF documents for your products
              </h2>
              <div class="banner__text mt-20 text-white wow move-up">
                Quality assurance documentation on the go!
              </div>
              <div
                class="saas-background__links section-space--mt_40 wow move-up"
              >
                <router-link
                  :to="{ path: '/go' }"
                  class="ht-btn ht-btn-md section-space--mb_40 signup"
                  >Start today</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 wow move-up">
          <div class="faq-banner__media">
            <img
              src="../assets/img/illustrations/file-manager.svg"
              class="img-fluid"
              alt
            />
            <!-- <img src="../assets/img/banners/aeroland-sass-image-01.png" class="img-fluid" alt /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerBgOne",
  data() {
    return {};
  },
};
</script>

<style scoped>
.bg-gradient {
  background-color: #aa6bcb;
  background-image: linear-gradient(
    141deg,
    #e2acff 0%,
    #ac4fdf 51%,
    #aa6bcb 75%
  );
}
</style>